import { Controller } from '@hotwired/stimulus';
import { useClickOutside } from 'stimulus-use';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
  static targets = ['button', 'close'];

  static values = {
    open: Boolean,
  };

  openValueChanged() {
    this.buttonTarget.setAttribute('aria-expanded', this.openValue);

    if (this.hasCloseTarget) {
      this.closeTarget.setAttribute('aria-expanded', this.openValue);
    }

    document.body.classList.toggle('has-submenu-opened', this.openValue);
  }

  connect() {
    useClickOutside(this);
  }

  toggle() {
    this.openValue = !this.openValue;
  }

  close() {
    this.openValue = false;
  }

  clickOutside() {
    this.close();
  }
}